"use strict";

var DisableOnSubmitMixin, HelpMixin, PasswordField, React, SingleInputMixin, StandardErrorDisplayMixin;

React = require("react");

SingleInputMixin = require("./mixins/SingleInput");

StandardErrorDisplayMixin = require("./mixins/StandardErrorDisplay");

DisableOnSubmitMixin = require("./mixins/DisableOnSubmit");

HelpMixin = require("./mixins/Help");

PasswordField = React.createClass({
  displayName: "PasswordField",

  mixins: [SingleInputMixin, StandardErrorDisplayMixin, DisableOnSubmitMixin, HelpMixin],
  onChange: function onChange(event) {
    return this.props.onDataChanged(this.props.dataKey, event.target.value);
  },
  render: function render() {
    var label, size;
    if (this.props.displayName !== false) {
      label = React.createElement(
        "label",
        { className: "col-sm-2 control-label", htmlFor: this.props.dataKey },
        this.props.displayName
      );
    }
    size = this.props.displayName === false ? "col-sm-12" : "col-sm-10";
    return React.createElement(
      "div",
      { className: this.errorClasses("form-group") },
      label,
      React.createElement(
        "div",
        { className: size },
        React.createElement("input", {
          type: "password",
          className: "form-control",
          name: this.props.dataKey,
          value: this.props.data,
          disabled: this.disabled(),
          onChange: this.onChange,
          placeholder: this.props.placeholder,
          title: this.props.title,
          onKeyPress: this.submitOnEnter
        }),
        this.errorSpan(),
        this.helpSpan()
      )
    );
  }
});

module.exports = PasswordField;


/*****************
 ** WEBPACK FOOTER
 ** ./lib/controls/Password.js
 ** module id = 555
 ** module chunks = 0
 **/